/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type HumanityHomeTotalTrxCountInfo = {
    TRXTP: HumanityHomeTotalTrxCountInfo.TRXTP;
    TTRXCNT: string;
};

export namespace HumanityHomeTotalTrxCountInfo {

    export enum TRXTP {
        NORMAL = 'NORMAL',
        INTERNAL = 'INTERNAL',
        PENDING = 'PENDING',
    }


}

